import auth from "../../middlewares/auth";
export const examQuestionsRoute = [
  {
    path: '/exam/questions',
    component: () => import(/* webpackChunkName: "exam_management" */ '../../views/exam_management/questions/QuestionList'),
    name: 'exam_questions',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/exam/questions/add',
    component: () => import(/* webpackChunkName: "exam_management" */ '../../views/exam_management/questions/QuestionForm'),
    name: 'exam_questions_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/exam/questions/edit/:id',
    component: () => import(/* webpackChunkName: "exam_management" */ '../../views/exam_management/questions/QuestionForm'),
    name: 'exam_questions_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/question/print/:question_id',
    component: () => import(/* webpackChunkName: "exam_management" */ '../../views/lecture_management/components/Print'),
    name: 'question_print',
    meta: {
        middleware: [
            auth
        ]
    }
}
];